import React from "react";
import {
  Authenticator,
  ThemeProvider,
  useTheme,
  View,
} from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { SvgIcon } from "@mui/material";

const components = {
  Header() {
    const { tokens } = useTheme();

    return (
      <View textAlign="center" padding={tokens.space.large}>
        <SvgIcon
          sx={{
            p: 0,
            height: 64,
            width: "auto",
          }}
          titleAccess="CopperheadSec Logo"
          alt="CopperheadSec Logo"
          viewBox="0 0 194 40"
        >
          <g fill="#fff" fillRule="evenodd" transform="translate(1 1)">
            <path d="m19 0c10.4934102 0 19 8.50658975 19 19 0 10.4934102-8.5065898 19-19 19-10.49341025 0-19-8.5065898-19-19 0-10.49341025 8.50658975-19 19-19zm-8.2939152 16.7858606h-2.07051236l8.21757086 14.3915122 8.4765187-14.3915122h-2.0271365l-6.4308339 10.8722369zm20.6449447-3.6456737h-16.4351416l1.0654205 1.775701h12.3312135l-6.2002164 11.0053839.9718066 1.7796628zm-6.3136463-3.37383176h-16.43514171l8.26691741 14.56074766.9718066-1.7796627-6.2002163-11.005384h12.3312134z" />
            <path
              d="m64.926 15.424c-.4800024-.5040025-1.0379968-.8969986-1.674-1.179s-1.2899966-.423-1.962-.423c-.8880044 0-1.7039963.2159978-2.448.648s-1.3319978 1.0169963-1.764 1.755-.648 1.5509956-.648 2.439c0 .8760044.2159978 1.6859963.648 2.43s1.0199963 1.3319978 1.764 1.764 1.5599956.648 2.448.648c.6600033 0 1.3079968-.1349986 1.944-.405s1.1999975-.6389977 1.692-1.107l1.044 1.134c-.6360032.6240031-1.3739958 1.1129982-2.214 1.467s-1.6919957.531-2.556.531c-1.200006 0-2.297995-.2849971-3.294-.855s-1.7819971-1.3469951-2.358-2.331-.864-2.0699941-.864-3.258c0-1.1760059.2909971-2.2529951.873-3.231s1.376995-1.7489972 2.385-2.313 2.1179939-.846 3.33-.846c.8760044 0 1.7249959.1649983 2.547.495.8220041.3300016 1.532997.794997 2.133 1.395zm9.676-3.132c1.2120061 0 2.3249949.2819972 3.339.846s1.8149971 1.3349951 2.403 2.313.882 2.0549941.882 3.231-.2939971 2.258995-.882 3.249-1.3889949 1.7699971-2.403 2.34-2.1269939.855-3.339.855-2.3249949-.2849971-3.339-.855-1.8149971-1.349995-2.403-2.34-.882-2.0729941-.882-3.249.2939971-2.2529951.882-3.231 1.385995-1.7489972 2.394-2.313 2.1239939-.846 3.348-.846zm.018 1.548c-.8760044 0-1.6889962.2159978-2.439.648s-1.3469978 1.0169963-1.791 1.755-.666 1.5509956-.666 2.439.2219978 1.7039963.666 2.448 1.0409962 1.3349978 1.791 1.773 1.5629956.657 2.439.657 1.6829963-.2189978 2.421-.657 1.3259978-1.0289963 1.764-1.773.657-1.5599956.657-2.448-.2189978-1.7009963-.657-2.439-1.0259963-1.3229978-1.764-1.755-1.5449956-.648-2.421-.648zm14.95-1.44c1.5720079 0 2.7869957.3719963 3.645 1.116s1.287 1.7879933 1.287 3.132c0 1.404007-.4319957 2.4929961-1.296 3.267s-2.0759922 1.161-3.636 1.161h-3.132v3.924h-1.728v-12.6zm-.072 7.11c1.0800054 0 1.9079971-.2369976 2.484-.711s.864-1.1729954.864-2.097c0-.9000045-.2879971-1.5809977-.864-2.043s-1.4039946-.693-2.484-.693l-3.06.018v5.526zm13.15-7.11c1.572008 0 2.786996.3719963 3.645 1.116s1.287 1.7879933 1.287 3.132c0 1.404007-.431996 2.4929961-1.296 3.267s-2.075992 1.161-3.636 1.161h-3.132v3.924h-1.728v-12.6zm-.072 7.11c1.080005 0 1.907997-.2369976 2.484-.711s.864-1.1729954.864-2.097c0-.9000045-.287997-1.5809977-.864-2.043s-1.403995-.693-2.484-.693l-3.06.018v5.526zm8.29-7.11h8.748v1.566h-7.02v3.888h6.282v1.566h-6.282v4.014h7.236v1.566h-8.964zm20.89 12.6-2.502-3.96c-.288001.0240001-.521999.036-.702.036h-3.204v3.924h-1.728v-12.6h4.932c1.596008 0 2.828996.3689963 3.699 1.107s1.305 1.7849932 1.305 3.141c0 1.0200051-.236998 1.8779965-.711 2.574s-1.154996 1.1999984-2.043 1.512l2.934 4.266zm-3.204-5.49c1.080005 0 1.907997-.2369976 2.484-.711s.864-1.1729954.864-2.097c0-.9000045-.287997-1.5809977-.864-2.043s-1.403995-.693-2.484-.693h-3.204v5.544zm9.082-7.11h1.728v5.616h7.2v-5.616h1.746v12.6h-1.746v-5.418h-7.2v5.418h-1.728zm15.274 0h8.748v1.566h-7.02v3.888h6.282v1.566h-6.282v4.014h7.236v1.566h-8.964zm22.114 12.6-1.332-3.06h-6.642l-1.314 3.06h-1.818l5.598-12.6h1.8l5.58 12.6zm-7.29-4.626h5.292l-2.664-6.12zm17.128-7.974c1.224006 0 2.330995.2729973 3.321.819s1.766997 1.2989952 2.331 2.259.846 2.0339941.846 3.222-.284997 2.2619952-.855 3.222-1.352995 1.7129973-2.349 2.259-2.111994.819-3.348.819h-5.076v-12.6zm.036 11.034c.876004 0 1.670996-.203998 2.385-.612s1.277998-.9719964 1.692-1.692.621-1.5239956.621-2.412c0-.9000045-.209998-1.7099964-.63-2.43s-.992996-1.2869979-1.719-1.701-1.532996-.621-2.421-.621h-3.366v9.468z"
              fillRule="nonzero"
            />
          </g>
        </SvgIcon>
      </View>
    );
  },
};

export default function SignIn() {
  const { tokens } = useTheme();
  const theme = {
    name: "Copperhead Dark Theme",
    tokens: {
      colors: {
        background: {
          primary: {
            value: tokens.colors.black.value,
          },
          secondary: {
            value: tokens.colors.green["100"].value,
          },
        },
        font: {
          primary: { value: tokens.colors.green["40"].value },
          interactive: {
            value: tokens.colors.white.value,
          },
        },
        brand: {
          primary: {
            10: tokens.colors.green["100"],
            80: tokens.colors.green["80"],
            90: tokens.colors.green["60"],
            100: tokens.colors.green["50"],
          },
        },
      },
    },
  };
  return (
    <ThemeProvider theme={theme}>
      <Authenticator
        components={components}
        hideSignUp
      ></Authenticator>
    </ThemeProvider>
  );
}
